import { z } from "zod";

export const EventShowSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  showDate: z.coerce.date(),
  sortOrder: z.number(),
  notes: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type EventShowDTO = z.infer<typeof EventShowSchema>;

export const CreateEventShowSchema = z.object({
  showDate: z.string().min(1, "ຕ້ອງລະບຸວັນໂຊ"),
  sortOrder: z.number().int().optional(),
  notes: z.string().nullable().optional(),
});
export type CreateEventShowDTO = z.infer<typeof CreateEventShowSchema>;

export const UpdateEventShowSchema = z.object({
  showDate: z.string().min(1).optional(),
  sortOrder: z.number().int().optional(),
  notes: z.string().nullable().optional(),
});
export type UpdateEventShowDTO = z.infer<typeof UpdateEventShowSchema>;

export const EventShowParamSchema = z.object({
  eventId: z.string().min(1),
  showId: z.string().min(1),
});
